import { api } from './../../api.js';
import { config } from './../../config.js';
import { fetchEventSessions } from '@/services/admin/events/eventsV2Service';

const actions = {
    BACK_CAMPANA_ABONOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.campana-abonos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_CAMPANA_ABONOS_GUARDAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.campana-abonos.guardar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_USER_VIEWER_ENVIAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.user_viewer.enviar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_USER_VIEWER_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.user_viewer.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_USER_VIEWER_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.user_viewer.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TICKETS_PUERTAS_UPDATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.tickets.puertas.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PUERTAS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.puertas.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PUERTAS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.puertas.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PUERTAS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.puertas.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PUERTAS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.puertas.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SALES_AD_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sales-ad.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SALES_AD_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sales-ad.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SALES_AD_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sales-ad.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SALES_AD_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sales-ad.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TICKETS_COPIAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.tickets.copiar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_BLOQUEAR_ASIENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.bloquear.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_BLOQUEAR_ASIENTOS_GENERAL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.bloquear.asientos.general'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PLANO_PDF : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.plano-pdf'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_EDITAR_DATOS_FISCALES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.editar.datos-fiscales'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_EDITAR_IMAGENES_ENTRADAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.editar.imagenes-entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_COMPANIES_VINCULAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.companies.vincular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_COMPANIES_DESVINCULAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.companies.desvincular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_LFP_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.lfp.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_EVO_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.evo.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_COMPARTIR_EVENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.compartir-entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VENTA_TAQUILLA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.venta-taquilla'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_DETALLE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.detalle'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SHOW_INFO_ENTRADAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.show-info-entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TAQUILLA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe-taquilla'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TOTAL_ENTRADAS_POR_PROVINCIA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.total-entradas-por-provincia'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TOTAL_ENTRADAS_POR_CP : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.total-entradas-por-cp'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TOTAL_ENTRADAS_VENDIDAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.total-entradas-vendidas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TOTAL_PRODUCTOS_VENDIDOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.total-productos-vendidos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_EMAILS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.emails'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_EMAILS_LISTADO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.emails.listado'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_WHATSAPP : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.whatsapp'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_RESUMEN_VENTAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.resumen-ventas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_RESUMEN_VENTAS_SESIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.resumen-ventas.sesiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_RESUMEN_VENTAS_SESION_DESGLOSE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.resumen-ventas.sesion.desglose'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_RESUMEN_VENTAS_DESCARGAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.resumen-ventas.descargar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_VENTA_DIARIA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.venta-diaria'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_OBSERVACIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.observaciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_ENTRADAS_OTROS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.entradas-otros'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_CONFIGURACION_INVITACIONES_ABONADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.configuracion-invitaciones-abonados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_DETALLE_INVITACIONES_ABONADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.detalle-invitaciones-abonados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ZONAS_INVITACIONES_ABONADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.zonas-invitaciones-abonados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_RECURRENTES_VS_NUEVOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.recurrentes-vs-nuevos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_CATEGORIAS_DEL_DISPOSITIVO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.categorias-dispositivos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TOTAL_GENEROS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.total-generos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_TOTAL_EDADES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.total-edades'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_COMPRAS_POR_HORA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.compras-por-hora'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    /**
     * Listado de sesiones de un evento, paginado y buscable en servidor.
     *
     * Va contra la superficie v2 (`GET /api/v2/events/{evento_id}/sessions`),
     * que NO cuelga de `/api1` como el resto del legacy: por eso usa el cliente
     * dedicado `eventsV2Service` en vez de `api.call`. El envelope devuelto es
     * el mismo que ya esperaba el composable ({ data: { data, meta } }).
     */
    BACK_EVENTS_SESIONES_INDEX : function({ commit }, data){
        return fetchEventSessions(data);
    },
    BACK_EVENTS_SESIONES_ZONAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ZONAS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.zonas.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_EXTRAS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.extras.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_EXTRAS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.extras.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_EXTRAS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.extras.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_EXTRAS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.extras.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_EXTRAS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.extras.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TICKETS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.tickets.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TICKETS_EDITAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.tickets.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TICKETS_EDITAR_ORDEN: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.tickets.editar-orden'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TICKETS_BORRAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.tickets.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_STOCK_COMPARTIDO_UPDATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.stock-compartido.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ENTRADAS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.entradas.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ENTRADAS_ENVIAR_EMAIL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.entradas.enviar.email'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ENTRADAS_ANULAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.entradas.anular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ENTRADAS_EDITAR_NOMBRE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.entradas.editar.nombre'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PEDIDO_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.pedido.editar.metodo-pago'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PEDIDO_ANULAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.pedido.anular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PEDIDO_PRODUCTOS_ANULAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.pedido.productos.anular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PEDIDO_ENVIAR_WHATSAPP : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.pedido.enviar.whatsapp'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_COMPRA_TAQUILLA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.compra.taquilla'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_GUARDAR_DATOS_COMPRADORES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.guardar-datos-compradores'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SHOW_NORMAL_ABONOS_VENTAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.show.normal-abonos-ventas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INVITACIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.invitaciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INVITACIONES_EVENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.invitaciones.eventos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INVITACIONES_COPIAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.invitaciones.copiar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VOUCHER_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.voucher.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VOUCHER_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.voucher.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VOUCHER_UPDATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.voucher.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VOUCHER_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.voucher.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_DESCUENTOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.descuentos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_DESCUENTOS_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.descuentos.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_DESCUENTOS_UPDATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.descuentos.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_DESCUENTOS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.descuentos.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VOUCHER_REGIONS_UPDATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.voucher_regions.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_VOUCHER_REGIONS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.voucher_regions.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_CONTROL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.control'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_INFORME_OCUPACION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.informe.ocupacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_LISTADO_BLOQUEOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.listado-bloqueos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_LISTADO_OCUPACION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.listado-ocupacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_INFORME_CONTROL_ACCESOS_ENTRADAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.informe.control-accesos.entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_INFORME_CONTROL_ACCESOS_ABONADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.informe.control-accesos.abonados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_INFORME_CONTROL_ACCESOS_ENTRADAS_OTROS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.informe.control-accesos.entradas-otros'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ENTRADAS_RECOGER_REGALO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.entradas.recoger.regalo'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_INFORME_ASIENTOS_LIBERADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.informe.asientos.liberados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ZONAS_PLAZAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.zonas.plazas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ZONAS_PLAZAS_ENTRADAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.zonas.plazas.entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_TAQUILLA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.taquilla'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_TICKETS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.tickets.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_TICKETS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.tickets.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_TICKETS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.tickets.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_PRECIOS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.precios.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_PRECIOS_GENERAL_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.precios.general.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PLAZAS_PRECIOS_SECTORES_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.plazas.precios.sectores.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RESERVAS_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.reservas.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RESERVAS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.reservas.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RESERVAS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.reservas.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RESERVAS_ENVIAR_EMAIL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.reservas.enviar-email'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RESERVAS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.reservas.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RESERVAS_GENERICAS_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.reservas.genericas.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENT_SESION_REGIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.event.sesion.regiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENT_SESION_REGION_IMPRIMIR_PEGATINAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.event.sesion.region.imprimir-pegatinas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_PUERTAS_EVENTO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.puertas-evento'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_ACTIVAR_CANCELAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.activar-cancelar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_ACREDITACIONES_CANCELAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.acreditaciones.cancelar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_ZONAS_BLOQUEAR_PLAZAS_TAQUILLA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.event.sesiones.zonas.taquilla.bloquear-plazas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTO_BLOQUEAR_PLAZAS_TAQUILLA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.event.sesiones.recinto.taquilla.bloquear-plazas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_BUTACAS_VISIBILIDAD_REDUCIDA_INDEX: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.butacas.visibilidad-reducida.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_BUTACAS_VISIBILIDAD_REDUCIDA_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.butacas.visibilidad-reducida.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_SECTORES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.sectores'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_GENERAL: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.general'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_ZONA_GENERAL: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.zona.general'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_ZONA_SECTORES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.zona.sectores'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_ZONA_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.zona.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_ZONAS_ANEXAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.regiones-anexas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_RECINTOS_SETTINGS_ZONAS_ANEXAS_PRECIOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.settings.regiones-anexas.precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_FORMS_CAMPOS_PERSONALIZADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.forms.campos-personalizados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_BUTACAS_GUARDAR_PRECIOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.butacas.guardar-precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_FORMS_CAMPOS_PERSONALIZADOS_ADD : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.forms.campos-personalizados.add'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_BUTACAS_GUARDAR_PRECIOS_SECTORES: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.butacas.guardar-precios-sectores'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_FORMS_CAMPOS_PERSONALIZADOS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.forms.campos-personalizados.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_BUTACAS_GUARDAR_PRECIOS_GENERAL: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.butacas.guardar-precios-general'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TAQUILLA_RECINTO_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.taquilla.recinto.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TAQUILLA_RECINTO_ZONAS_SIN_ASIENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.taquilla.recinto.zonas-sin-asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_REGIONES_PLAZAS_TAQUILLA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.regiones.plazas.taquilla'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TAQUILLA_RECINTO_ZONAS_ANEXAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.taquilla.recinto.zonas-anexas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_TAQUILLA_RECINTO_ZONAS_ANEXAS_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.taquilla.recinto.zonas-anexas.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PRODUCTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.productos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PRODUCTOS_ADD: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.productos.add'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PRODUCTOS_EDIT: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.productos.edit'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PRODUCTOS_DELETE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.productos.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PRODUCTOS_COPIAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.productos.copiar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_COMPRADORES_PERMITIDOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.compradores-permitidos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_COMPRADORES_PERMITIDOS_ADD: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.compradores-permitidos.add'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_COMPRADORES_PERMITIDOS_DELETE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesion.compradores-permitidos.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_PRODUCTOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.productos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_GET_PRODUCTS_LINKED_EVENTS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.get.products.linked.events'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SYNC_PRODUCTS_LINKED_EVENTS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sync.products.linked.events'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_CODIGOS_QR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.codigos-qr'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_CODIGOS_QR_GENERAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.codigos-qr.generar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_CODIGOS_QR_EXPORTAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.codigos-qr.exportar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_SESIONES_CODIGOS_QR_ELININAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.sesiones.codigos-qr.eliminar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_LISTADO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.listado'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_LISTADO_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.editar'),data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_DESCARGAR_INFORME: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.descargar-informe'),data, { responseType: 'blob' }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_GESTIONAR_SOLICITUDES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.gestionar-solicitudes'),data, { responseType: 'blob' }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_REENVIAR_EMAIL: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.reenviar-email'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_ENTRADAS_PREVISTAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.entradas-previstas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_EVENTS_PREVENTA_ENTRADAS_COMPRADAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.events.preventa.entradas-compradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};
